import React from 'react'
import { useTranslation } from 'react-i18next'
import { Header } from '../components/Header'
import { Footer } from '../components/Footer'

export const GettingStarted: React.FC = () => {
  const { t } = useTranslation()
  const gettingStarted = t('gettingStarted', { returnObjects: true }) as any

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20 pb-16">
        <div className="max-w-5xl mx-auto px-4 py-8">
          {/* Header */}
          <div className="text-center mb-12">
            <h1 className="text-3xl font-bold text-gray-900 mb-4">{gettingStarted.title}</h1>
            <p className="text-lg text-gray-600">{gettingStarted.subtitle}</p>
          </div>

          {/* Sections */}
          <div className="space-y-8">
            {gettingStarted.sections.map((section: any, index: number) => (
              <div
                key={index}
                className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-shadow"
              >
                <div className="flex items-start gap-4">
                  {/* Icon */}
                  <div className="flex-shrink-0 text-4xl">
                    {section.icon}
                  </div>

                  {/* Content */}
                  <div className="flex-1">
                    <h2 className="text-xl font-semibold text-gray-900 mb-3">
                      {section.title}
                    </h2>

                    {/* Text Content */}
                    {section.content && (
                      <p className="text-gray-700 leading-relaxed">
                        {section.content}
                      </p>
                    )}

                    {/* List Items */}
                    {section.items && (
                      <ul className="space-y-2">
                        {section.items.map((item: string, itemIndex: number) => (
                          <li
                            key={itemIndex}
                            className="flex items-start text-gray-700"
                          >
                            <span className="text-blue-600 mr-2 mt-1 flex-shrink-0">•</span>
                            <span>{item}</span>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* CTA Section */}
          <div className="mt-12 p-8 bg-gradient-to-r from-blue-600 to-purple-600 rounded-lg text-center text-white">
            <h2 className="text-2xl font-bold mb-3">{gettingStarted.cta.title}</h2>
            <p className="text-blue-100 mb-6">
              {gettingStarted.cta.description}
            </p>
            <a
              href="#demo"
              className="inline-flex items-center px-8 py-3 bg-white text-blue-600 font-semibold rounded-lg hover:bg-gray-100 transition-colors"
            >
              {gettingStarted.cta.button}
              <span className="ml-2">→</span>
            </a>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  )
}
